export interface IPartnerThemeScheme {
    primary: string | null;
    secondary: string | null;
    tertiary: string | null;
    error: string | null;
    surface: string | null;
    onSurface: string | null;

    surfaceContainer: string | null;
    surfaceContainerHigh: string | null;
    surfaceContainerHighest: string | null;
    outline: string | null;
    outlineVariant: string | null;

    bg: string | null;
    panel: string | null;
    card: string | null;
    cardForeground: string | null;
    border: string | null;
    muted: string | null;
    mutedForeground: string | null;
    ring: string | null;
}

export interface IPartnerThemeMeta {
    defaultMode: 'light' | 'dark';
    homePageLink: string | null;
    tenantName: string | null;
    tenantTitle: string | null;
    emailFromName: string | null;
    emailFromAddress: string | null;
}

export interface IPartnerThemeAssets {
    logoFileName: string | null;
    logoUrl?: string | null;
    logoDarkFileName: string | null;
    logoDarkUrl?: string | null;
    faviconFileName: string | null;
    faviconUrl?: string | null;
    faviconDarkFileName: string | null;
    faviconDarkUrl?: string | null;
    landingFileName: string | null;
}

export interface IPartnerTheme {
    id: number | null;
    partnerId: number;

    meta: IPartnerThemeMeta;
    assets: IPartnerThemeAssets;

    schemes: {
        light: IPartnerThemeScheme;
        dark: IPartnerThemeScheme;
    };
}

export interface IPartnerThemeView extends IPartnerTheme {
    exists: boolean;
    createDate?: string | null;

    logoUrl?: string | null;
    logoDarkUrl?: string | null;
    faviconUrl?: string | null;
    faviconDarkUrl?: string | null;
    landingUrl?: string | null;
}

export enum PartnerThemeAssetType {
    logo = 1,
    logoDark = 2,
    favicon = 3,
    faviconDark = 4,
    landing = 5,
}

export interface IPartnerThemeAsset {
    assetType: PartnerThemeAssetType;
    fileName: string;
    url: string;
}
